import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStateService {
  public token: WritableSignal<string | null> = signal(null);
  public refreshToken: WritableSignal<string | null> = signal(null);
  public userId: WritableSignal<string | null> = signal(null);
  public accountId: WritableSignal<string | null> = signal(null);
  public ownerId: WritableSignal<string | null> = signal(null);
  public planId: WritableSignal<string | null> = signal(null);
  public rol: WritableSignal<string | null> = signal(null);

  constructor() {
    this.hydrate();
  }

  public hydrate(): void {
    if (typeof localStorage !== 'undefined') {
      this.token.set(localStorage.getItem('token'));
      this.refreshToken.set(localStorage.getItem('refreshToken'));
      this.userId.set(localStorage.getItem('userId'));
      this.accountId.set(localStorage.getItem('accountId'));
      this.ownerId.set(localStorage.getItem('ownerId'));
      this.planId.set(localStorage.getItem('planId'));
      this.rol.set(localStorage.getItem('rol'));
    }
  }

  public setSession(data: {
    token?: string;
    refreshToken?: string;
    userId?: string;
    accountId?: string;
    ownerId?: string;
    planId?: string;
    rol?: string;
  }): void {
    if (typeof localStorage !== 'undefined') {
      if (data.token) {
        localStorage.setItem('token', data.token);
        this.token.set(data.token);
      }
      if (data.refreshToken) {
        localStorage.setItem('refreshToken', data.refreshToken);
        this.refreshToken.set(data.refreshToken);
      }
      if (data.userId) {
        localStorage.setItem('userId', data.userId);
        this.userId.set(data.userId);
      }
      if (data.accountId) {
        localStorage.setItem('accountId', data.accountId);
        this.accountId.set(data.accountId);
      }
      if (data.ownerId) {
        localStorage.setItem('ownerId', data.ownerId);
        this.ownerId.set(data.ownerId);
      }
      if (data.planId) {
        localStorage.setItem('planId', data.planId);
        this.planId.set(data.planId);
      }
      if (data.rol) {
        localStorage.setItem('rol', data.rol);
        this.rol.set(data.rol);
      }
    }
  }

  public clearSession(): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('accountId');
      localStorage.removeItem('ownerId');
      localStorage.removeItem('planId');
      localStorage.removeItem('rol');
    }

    this.resetMemoryOnly();
  }

  public resetMemoryOnly(): void {
    this.token.set(null);
    this.refreshToken.set(null);
    this.userId.set(null);
    this.accountId.set(null);
    this.ownerId.set(null);
    this.planId.set(null);
    this.rol.set(null);
  }
}
